export const KEY_SHIFT_EDGES = {
    'shift+down': 'bottom',
    'shift+left': 'left',
    'shift+right': 'right',
    'shift+up': 'top',
};
